/*********************** Custom JS for Boost AI Search & Discovery  ************************/
let myData = {};
const customize = {
    updateBtns: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Modify Product Buttons',
            enabled: true,
            apply: () => ({
                props: (props) => {
                  myData = props.product;
                  return props
                },
                afterRender(element) {
let data = element.getParams().props.product;

                  //console.log(data)
let activeimageurl = ''
let productItem = document.querySelector('[id="' + data.id + '"]');

//be sure to only set if it hasn't been set already
if (productItem && productItem.querySelector('.lowestpriceset') == null && productItem.querySelector('.boost-sd__product-info') !== null) {
  let variants = data.variants.filter(variant => variant.available)
  if (variants.length == 0) {
    variants = data.variants
  }
    //find the lowest price of active items
    let lowestactualprice = 0
  let compare_price = 0
    for (var i = 0; i < variants.length; i++) { 
    //console.log(variants[i]);
      var numberprice = Number(variants[i].price)
      if(lowestactualprice == 0) {
          if(numberprice > 0 && variants[i].inventory_quantity > 0) {
            lowestactualprice  = numberprice
            compare_price = variants[i].compare_at_price
            //console.log('lowestactualprice 0 '+lowestactualprice)
          }
      } else { 
          if(numberprice > 0 && numberprice < lowestactualprice && variants[i].inventory_quantity > 0) {
            lowestactualprice  = numberprice
            compare_price = variants[i].compare_at_price
            //console.log('lowestactualprice 2 '+lowestactualprice)
          }
      }

       //image
      if (activeimageurl == '') {
        if (variants[i].available == true && variants[i].inventory_quantity > 0) {
          activeimageurl = variants[i].image + '&width=320&state=edited'
        }
      }
  }

  productItem.setAttribute("safeimage", activeimageurl);

  //hide 0 prices
  if (productItem && productItem.querySelector('.boost-sd__format-currency') !== null && productItem.querySelector('.boost-sd__product-info') !== null) {
      productItem.querySelector('.boost-sd__format-currency').classList.add('lowestpriceset');
    if(lowestactualprice == 0) {
      productItem.querySelector('.boost-sd__format-currency').innerHTML = ('Click for More Info');
    } else {
      productItem.querySelector('.boost-sd__format-currency').innerHTML = ('$'+lowestactualprice);
      if (!productItem.querySelector('.boost-sd__format-currency--price-compare span') && compare_price != 0) {
        productItem.querySelector('.boost-sd__format-currency').insertAdjacentHTML('afterend', '<span class="boost-sd__format-currency boost-sd__format-currency--price-compare" style="color: rgb(152, 152, 152); font-family: Montserrat; font-style: normal; font-weight: 400; font-size: 12px;"><span class="">$'+compare_price+'</span></span>')
      }
    }
      
  }
}





//Add Brands
if (productItem && productItem.querySelector('.metafield') == null && productItem.querySelector('.boost-sd__product-info') !== null) {
  let productMetafield = document.createElement('div');
  productMetafield.classList.add('metafield');
    let brands = data.metafields.filter(function(e) {
    return e.namespace == 'details' && e.key == 'brand' && e.value !== null;
  })
  
  if (brands == null) {
      brands = '';
  }
  
  productMetafield.textContent = brands[0].value
  productItem.querySelector('.boost-sd__product-info').prepend(productMetafield);
}
// END Add Brands



// Add Reviews 1
if (productItem && productItem.querySelector('.ratings') == null && productItem.querySelector('.boost-sd__product-info') !== null ) {
  let itemReviewsMeta = ''
  let itemReviewsMetaHTML = ''
  let itemReviewsMetaDiv = document.createElement('div');
  itemReviewsMetaDiv.classList.add('ratings');
  if(productItem.querySelector('.boost-sd__product-swatch') == null) {

    console.log('null')
  }
  const swatchEle = productItem.querySelector('.boost-sd__product-swatch')
  if(swatchEle){
    swatchEle.prepend(itemReviewsMetaDiv);
  }
  // productItem.querySelector('.boost-sd__product-swatch').prepend(itemReviewsMetaDiv)

  let itemReviewsMetaData = data.metafields.filter(function(e) {
    return e.namespace == 'turnto' && e.key == 'product_rating' && e.value !== null;
  })
  if(itemReviewsMetaData.length > 0) {
      itemReviewsMeta = itemReviewsMetaData[0].value
        if(itemReviewsMeta > 2) {
          itemReviewsMetaHTML += '<div class="tt-container tt-product-block"><span class="tt-product-block__stars" data-open-accessibility-text-original="14px" style="font-size: 14px; padding-top: 5px; display:block;">'
          
          if(itemReviewsMeta == 5) {
            itemReviewsMetaHTML += '<span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span>'
          } else if (itemReviewsMeta > 4) {
            itemReviewsMetaHTML += '<span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><span class="TTteaser__star"><svg class="TTteaser__icon--half"><use xlink:href="#tt-teaser-star--half"></use></svg></span>'
          } else if (itemReviewsMeta == 4) {
            itemReviewsMetaHTML += '<span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span>'
          } else if (itemReviewsMeta > 3) {
            itemReviewsMetaHTML += '<span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><span class="TTteaser__star"><svg class="TTteaser__icon--half"><use xlink:href="#tt-teaser-star--half"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span>'
          } else if (itemReviewsMeta == 3) {
            itemReviewsMetaHTML += '<span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span>'
          } else if (itemReviewsMeta > 2) {
            itemReviewsMetaHTML += '<span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><span class="TTteaser__star"><svg class="TTteaser__icon--half"><use xlink:href="#tt-teaser-star--half"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span>'
          } else if (itemReviewsMeta == 2) {
            itemReviewsMetaHTML += '<span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span>'
          } else if (itemReviewsMeta > 1) {
            itemReviewsMetaHTML += '<span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><span class="TTteaser__star"><svg class="TTteaser__icon--half"><use xlink:href="#tt-teaser-star--half"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span>'
          } else if (itemReviewsMeta == 1) {
            itemReviewsMetaHTML += '<span class="TTteaser__star"><svg class="TTteaser__icon--full"><use xlink:href="#tt-teaser-star--full"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span>'
          } else if (itemReviewsMeta > 0) {
            itemReviewsMetaHTML += '<span class="TTteaser__star"><svg class="TTteaser__icon--half"><use xlink:href="#tt-teaser-star--half"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span><span class="TTteaser__star"><svg class="TTteaser__icon--empty"><use xlink:href="#tt-teaser-star--empty"></use></svg></span>'
          }
          itemReviewsMetaHTML += '</span></div>'
        }
      //itemReviewsMetaDiv.textContent = itemReviewsMetaHTML
    const ratingsElement = productItem.querySelector('.ratings');
      if (ratingsElement) {
        ratingsElement.innerHTML = itemReviewsMetaHTML;
      }
      // productItem.querySelector('.ratings').innerHTML = (itemReviewsMetaHTML);
  }
}
// END Add Reviews

                   //cleanup
                  setTimeout(function() {
                    pricingCleanupCollection()
                    safeImageCleanup()
                  }, 1000);

                }
            }),
        });
    },
    updateSwatches: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductSwatchOption', {
            name: 'ProductSwatchOption - Custom Swatch Image Url',
            apply: () => ({
                props: (props) => {
                    if (props.labelAs === 'image') {

                        const _label = props.label;

                        if(props.label === 'Kelly Green' || props.label === 'Emerald Green') props.labelStyle = {
                          backgroundColor: '#008000',
                        };
                      
                        if(props.label === 'Sky Blue' || props.label === 'Graphite Blue') props.labelStyle = {
                          backgroundColor: '#0000ff',
                        };
                      
                        if(props.label === 'Pale Pink') props.labelStyle = {
                          backgroundColor: '#ffc0cb',
                        };
                      
                        if(props.label === 'Rich Brown') props.labelStyle = {
                          backgroundColor: '#a52a2a',
                        };
                        
                        if(props.label === 'Sharkey Grey' || props.label === 'White / Grey') props.labelStyle = {
                          backgroundColor: '#808080',
                        };
                                            
                       props.customSwatchImageUrl = (fileBaseUrl) => {
                            const newFileBaseUrl = 'https://www.realrooms.com/cdn/shop/files/';
                            const customizeName = _label.toLowerCase().replaceAll(' ', '-'); // do some thing to convert _label to name file
                            return `url(${newFileBaseUrl}${customizeName}_50x50.png)`
                        };
                        /* this linking doesn't seem to work. updating to pull from the url provided on PDP swatches (above) -teeple 8/8/23
                        props.customSwatchImageUrl = (fileBaseUrl) => {
                            const newFileBaseUrl = 'https://cdn.shopify.com/s/files/1/0345/1237/1850/t/47/assets/';
                            const customizeName = _label.toLowerCase().replaceAll(' ', '-'); // do some thing to convert _label to name file
                            return `url(${newFileBaseUrl}${customizeName}_50x.png)`
                        };
                        */
                    }
                    return props;
                }
            }),
        });
    },
    removeOOSProductSwatches: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductSwatch', {
            name: 'Remove OOS swatches #187608',
            enabled: true,
            apply: () => ({
                props: (props) => {
                  let dataVariants = myData.variants || []; // Get product variant to check 
                  let newProps = props.options.filter((option) => {
                            let optionValue = option.value;
                            if (checkOptionStatus(dataVariants, optionValue)) {
                                return option;
                            }
                        })
                  props.options = newProps;

                  return props
                },

              
            }),
         });
    }
}

// Function check option available or not
function checkOptionStatus(variants, optionValue) {
  for (let i = 0; i < variants.length; i++) {
    const variant = variants[i];
    const variantOptions = variant.title.split(' / ');
    if (variantOptions.some(option => option.toLowerCase() === optionValue.toLowerCase() && variant.available)) {
      return true;
    }
  }
  return false;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateBtns, customize.updateSwatches, customize.removeOOSProductSwatches]);

/* Start Boost 182931 */
/* DECO Products Labels & Badges integration */
if (window.boostSDAppConfig) {  window.boostSDAppConfig.integration =  Object.assign({     labels: 'deco' }, window.boostSDAppConfig.integration || {});}
/* End Boost 182931 */